<template>
  <div class="data">
    <p class="text-c f-s-16">资料目录</p>
    <van-row class="data">
      <van-col
        :span="24"
        class="f-s-6 m-t-045 xz-p-r-05 dataItem"
        v-for="(item, index) in dlist"
        :key="index"
      >
        <svg
          class="icon f-l-l"
          aria-hidden="true"
          style="height: 1.4rem; width: 1.4rem"
        >
          <use :xlink:href="iconClassName(item.type)"></use>
        </svg>

        <p class="f-l-l dataTitle">
          {{ item.dtitle }}
        </p>
        <span class="f-l-r sizeSty">{{ item.size }}</span>
        <!-- <van-divider /> -->
      </van-col>
    </van-row>
  </div>
</template>

<script>
import "@/assets/icon/iconfont.js";

export default {
  props: {
    dlist: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
  },
  watch: {
    dlist: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val == []) return false;
        val.forEach((item) => {
          item.type = item.dtitle
            .substring(item.dtitle.indexOf(".") + 1)
            .toLowerCase();
        });
      },
    },
  },
};
</script>

<style lang="less" scoped>
.data {
max-height: 8.5rem; overflow: auto
}
.dataItem {
  height: 1.75rem;
  max-height: 1.75rem;
  line-height: 1.75rem;
  border-bottom: 1px solid #f2f2f2;
}
.dataTitle {
  max-width: 55vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sizeSty {
  max-width: 15vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
